define((require) => {
    "use strict";

    var _                       = require("underscore"),
        ProjectContentItemView  = require("ui/projects/content/ProjectContentItemView"),
        Tooltip                 = require("ui/common/Tooltip");

    /**
     * The <tt>ProjectContentItemView</tt> to appear in the attach dialog.
     */
    return ProjectContentItemView.extend({

        viewOptions: {
            showExperienceActionsPanel: false,
            showSelectIndicator: true
        },

        _selected: false,

        ui: function() {
            return _.defaults({
                selectIndicator: ".select-indicator",
                selectIndicatorInOtherProject: ".select-indicator.in-other-project",
                selectIndicatorInOtherProjectSelected: ".select-indicator.in-other-project-selected"
            }, ProjectContentItemView.prototype.ui);
        },

        events: function() {
            return _.defaults({
                "click @ui.thumbContainer": function() {
                    // Overwrite this click event to avoid opening the quickview
                },

                "click @ui.groupThumbContainer": function() {
                    // Overwrite this click event to avoid opening the quickview
                },

                "click @ui.thumbWrapper": "_toggleSelection",
                "click @ui.selectIndicator": "_toggleSelection"
            }, ProjectContentItemView.prototype.events);
        },

        _toggleSelection: function() {
            this._selected = !this._selected;

            this.options.selectHandler(this.model, this._selected);

            this.$el.toggleClass("selected");
        },

        onRender: function() {
            this.__super();

            var projectContext = this.options.projectContext,
                projectID = this.options.contentMap.get(this.model.get("id"));

            if (projectID) {
                this.$el.addClass(projectID === projectContext.project.get("id") ? "in-project" : "in-other-project");
            } else {
                this.$el.removeClass("in-project in-other-project");
            }

            Tooltip.add(this.ui.selectIndicatorInOtherProject, {
                placement: "top",
                alignCenter: true,
                width: 250
            });

            Tooltip.add(this.ui.selectIndicatorInOtherProjectSelected, {
                placement: "top",
                alignCenter: true,
                width: 200
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/content/ProjectAttachContentItemView.js